import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Capture beforeinstallprompt immediately — it fires before React mounts.
// PWAInstallPrompt reads window.__pwaInstallPrompt on mount so it never misses it.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// In development, unregister any previously-registered service worker so stale
// SWs don't fire controllerchange → window.location.reload() after each build.
// In production, register normally and surface updates via a custom event.
if (process.env.NODE_ENV === 'development') {
  // Unregister any lingering service workers and do ONE reload so the next
  // load is completely SW-free. On subsequent loads regs.length === 0 → no
  // reload → permanently clean. This prevents the old SW's cache-first
  // strategy from intercepting CRA's HMR JS bundles and causing a reload loop.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(regs => {
      if (regs.length > 0) {
        Promise.all(regs.map(r => r.unregister())).then(() => {
          window.location.reload();
        });
      }
    });
  }
} else {
  serviceWorkerRegistration.register({
    onUpdate: () => {
      window.dispatchEvent(new CustomEvent('sw-update-available'));
    },
  });
}
